import useCachedList from './CachedList';
import { useFindProceduresForSelectionLazy } from '@src/adapters/hooks/procedures/useFindProceduresForSelection';
import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';

const ProcedureList = () => {
  return useCachedList<ProcedureDTO>(
    'procedureList',
    useFindProceduresForSelectionLazy
  );
};

export default ProcedureList;
